/* eslint-disable */
// tslint:disable
/**
 * Кабинет муниципалитета
 * todo
 *
 * OpenAPI spec version: 1.4.0
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator+.
 * https://github.com/karlvr/openapi-generator-plus
 * Do not edit the class manually.
 */

import { Configuration } from "./configuration";
import { BASE_PATH, COLLECTION_FORMATS, FetchAPI, FetchArgs, BaseAPI, RequiredError, defaultFetch } from "./runtime";
import { Api } from "./models";

export type FactoryFunction<T> = (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) => T;

/**
 * BannersApi - fetch parameter creator
 * @export
 */
export const BannersApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Returns list of banners</p>
		 * @summary Returns list of banners
		 * @param {number} subjectId
		 * @param {string} subjectType
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getBanners(subjectId: number, subjectType: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'subjectId' is not null or undefined
			if (subjectId === null || subjectId === undefined) {
				throw new RequiredError('subjectId', 'Required parameter subjectId was null or undefined when calling getBanners.');
			}
			// verify required parameter 'subjectType' is not null or undefined
			if (subjectType === null || subjectType === undefined) {
				throw new RequiredError('subjectType', 'Required parameter subjectType was null or undefined when calling getBanners.');
			}
			let localVarPath = `/api/content/public/banners`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (subjectId !== undefined) {
				localVarQueryParameter.append('subject_id', String(subjectId));
			}

			if (subjectType !== undefined) {
				localVarQueryParameter.append('subject_type', String(subjectType));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>logged show banner</p>
		 * @summary logged show banner
		 * @param {number} bannerId
		 * @param {Api.LoggedShowBannerRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		loggedShowBanner(bannerId: number, request: Api.LoggedShowBannerRequest | undefined, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'bannerId' is not null or undefined
			if (bannerId === null || bannerId === undefined) {
				throw new RequiredError('bannerId', 'Required parameter bannerId was null or undefined when calling loggedShowBanner.');
			}
			let localVarPath = `/api/content/public/banners/{banner_id}/logged_show`
				.replace('{banner_id}', encodeURIComponent(String(bannerId)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * BannersApi - functional programming interface
 * @export
 */
export const BannersApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Returns list of banners</p>
		 * @summary Returns list of banners
		 * @param {number} subjectId
		 * @param {string} subjectType
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getBanners(subjectId: number, subjectType: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetBanners200Response[]> {
			const localVarFetchArgs = BannersApiFetchParamCreator(configuration).getBanners(subjectId, subjectType, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>logged show banner</p>
		 * @summary logged show banner
		 * @param {number} bannerId
		 * @param {Api.LoggedShowBannerRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		loggedShowBanner(bannerId: number, request: Api.LoggedShowBannerRequest | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = BannersApiFetchParamCreator(configuration).loggedShowBanner(bannerId, request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 204) {
						return response;
					}
					if (response.status === 404) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * BannersApi - factory interface
 * @export
 */
export const BannersApiFactory: FactoryFunction<BannersApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new BannersApi(configuration, basePath, fetch);
};

/**
 * BannersApi - object-oriented interface
 * @export
 * @class BannersApi
 * @extends {BaseAPI}
 */
export class BannersApi extends BaseAPI {
	/**
	 * <p>Returns list of banners</p>
	 * @summary Returns list of banners
	 * @param {number} subjectId
	 * @param {string} subjectType
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getBanners(subjectId: number, subjectType: string, options?: RequestInit) {
		return BannersApiFp(this.configuration).getBanners(subjectId, subjectType, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>logged show banner</p>
	 * @summary logged show banner
	 * @param {number} bannerId
	 * @param {Api.LoggedShowBannerRequest} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public loggedShowBanner(bannerId: number, request: Api.LoggedShowBannerRequest | undefined, options?: RequestInit) {
		return BannersApiFp(this.configuration).loggedShowBanner(bannerId, request, options)(this.fetch, this.basePath);
	}

}
/**
 * FeaturesApi - fetch parameter creator
 * @export
 */
export const FeaturesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Получение списка доступных пользователю функциональностей</p>
		 * @summary Получение данных
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getListFeatures(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/features`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * FeaturesApi - functional programming interface
 * @export
 */
export const FeaturesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Получение списка доступных пользователю функциональностей</p>
		 * @summary Получение данных
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getListFeatures(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string[]> {
			const localVarFetchArgs = FeaturesApiFetchParamCreator(configuration).getListFeatures(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * FeaturesApi - factory interface
 * @export
 */
export const FeaturesApiFactory: FactoryFunction<FeaturesApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new FeaturesApi(configuration, basePath, fetch);
};

/**
 * FeaturesApi - object-oriented interface
 * @export
 * @class FeaturesApi
 * @extends {BaseAPI}
 */
export class FeaturesApi extends BaseAPI {
	/**
	 * <p>Получение списка доступных пользователю функциональностей</p>
	 * @summary Получение данных
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getListFeatures(options?: RequestInit) {
		return FeaturesApiFp(this.configuration).getListFeatures(options)(this.fetch, this.basePath);
	}

}
/**
 * FeedbacksApi - fetch parameter creator
 * @export
 */
export const FeedbacksApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Create feedback</p>
		 * @summary Create feedback
		 * @param {Api.CreateFeedbackRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		createFeedback(request: Api.CreateFeedbackRequest | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/feedbacks`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Позволяет загрузить файл для прикрепления к форме обратной связи и получить его id</p>
		 * @summary Loading feedback attachment to server
		 * @param {Api.UploadFeedbackAttachmentRequest.MultipartFormData} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		uploadFeedbackAttachment(request: Api.UploadFeedbackAttachmentRequest.MultipartFormData | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/feedbacks/attachments`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'multipart/form-data');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				const localVarFormData = new FormData();
				if (request.file !== undefined) {
					localVarFormData.append('file', request.file.value, request.file.filename);
				}
				localVarRequestOptions.body = localVarFormData;
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * FeedbacksApi - functional programming interface
 * @export
 */
export const FeedbacksApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Create feedback</p>
		 * @summary Create feedback
		 * @param {Api.CreateFeedbackRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		createFeedback(request: Api.CreateFeedbackRequest | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = FeedbacksApiFetchParamCreator(configuration).createFeedback(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 204) {
						return response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Позволяет загрузить файл для прикрепления к форме обратной связи и получить его id</p>
		 * @summary Loading feedback attachment to server
		 * @param {Api.UploadFeedbackAttachmentRequest.MultipartFormData} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		uploadFeedbackAttachment(request: Api.UploadFeedbackAttachmentRequest.MultipartFormData | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.UploadFeedbackAttachment200Response> {
			const localVarFetchArgs = FeedbacksApiFetchParamCreator(configuration).uploadFeedbackAttachment(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 413) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * FeedbacksApi - factory interface
 * @export
 */
export const FeedbacksApiFactory: FactoryFunction<FeedbacksApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new FeedbacksApi(configuration, basePath, fetch);
};

/**
 * FeedbacksApi - object-oriented interface
 * @export
 * @class FeedbacksApi
 * @extends {BaseAPI}
 */
export class FeedbacksApi extends BaseAPI {
	/**
	 * <p>Create feedback</p>
	 * @summary Create feedback
	 * @param {Api.CreateFeedbackRequest} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public createFeedback(request: Api.CreateFeedbackRequest | undefined, options?: RequestInit) {
		return FeedbacksApiFp(this.configuration).createFeedback(request, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Позволяет загрузить файл для прикрепления к форме обратной связи и получить его id</p>
	 * @summary Loading feedback attachment to server
	 * @param {Api.UploadFeedbackAttachmentRequest.MultipartFormData} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public uploadFeedbackAttachment(request: Api.UploadFeedbackAttachmentRequest.MultipartFormData | undefined, options?: RequestInit) {
		return FeedbacksApiFp(this.configuration).uploadFeedbackAttachment(request, options)(this.fetch, this.basePath);
	}

}
/**
 * GratitudesApi - fetch parameter creator
 * @export
 */
export const GratitudesApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Доступность раздела благодарностей</p>
		 * @summary Доступность раздела благодарностей
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		checkGratitudesAvailable(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/gratitudes/check_available`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Показатели региона</p>
		 * @summary Показатели региона
		 * @param {number} gratitudeId
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		downloadGratitude(gratitudeId: number, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'gratitudeId' is not null or undefined
			if (gratitudeId === null || gratitudeId === undefined) {
				throw new RequiredError('gratitudeId', 'Required parameter gratitudeId was null or undefined when calling downloadGratitude.');
			}
			let localVarPath = `/api/content/public/gratitudes/{gratitude_id}/download`
				.replace('{gratitude_id}', encodeURIComponent(String(gratitudeId)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Список благодарностей</p>
		 * @summary Список благодарностей
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getGratitudes(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/gratitudes`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * GratitudesApi - functional programming interface
 * @export
 */
export const GratitudesApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Доступность раздела благодарностей</p>
		 * @summary Доступность раздела благодарностей
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		checkGratitudesAvailable(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GratitudesAvailable> {
			const localVarFetchArgs = GratitudesApiFetchParamCreator(configuration).checkGratitudesAvailable(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Показатели региона</p>
		 * @summary Показатели региона
		 * @param {number} gratitudeId
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		downloadGratitude(gratitudeId: number, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = GratitudesApiFetchParamCreator(configuration).downloadGratitude(gratitudeId, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/pdf') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Список благодарностей</p>
		 * @summary Список благодарностей
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getGratitudes(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.Gratitude[]> {
			const localVarFetchArgs = GratitudesApiFetchParamCreator(configuration).getGratitudes(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * GratitudesApi - factory interface
 * @export
 */
export const GratitudesApiFactory: FactoryFunction<GratitudesApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new GratitudesApi(configuration, basePath, fetch);
};

/**
 * GratitudesApi - object-oriented interface
 * @export
 * @class GratitudesApi
 * @extends {BaseAPI}
 */
export class GratitudesApi extends BaseAPI {
	/**
	 * <p>Доступность раздела благодарностей</p>
	 * @summary Доступность раздела благодарностей
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public checkGratitudesAvailable(options?: RequestInit) {
		return GratitudesApiFp(this.configuration).checkGratitudesAvailable(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Показатели региона</p>
	 * @summary Показатели региона
	 * @param {number} gratitudeId
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public downloadGratitude(gratitudeId: number, options?: RequestInit) {
		return GratitudesApiFp(this.configuration).downloadGratitude(gratitudeId, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Список благодарностей</p>
	 * @summary Список благодарностей
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getGratitudes(options?: RequestInit) {
		return GratitudesApiFp(this.configuration).getGratitudes(options)(this.fetch, this.basePath);
	}

}
/**
 * MunicipalityTasksApi - fetch parameter creator
 * @export
 */
export const MunicipalityTasksApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Получение данных по актуальному состоянию прохождения этапов и информационнных данных</p>
		 * @summary Получение данных
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getMunicipalityTasks(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/municipality_tasks`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Скачать расписание олимпиад</p>
		 * @summary Скачать расписание олимпиад
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		olimpiadsDownload(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public//municipality_tasks/olimpiads_download`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Обновление состояния</p>
		 * @summary Обновление состояния
		 * @param {Api.UpdateStatusTaskRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		updateStatusTask(request: Api.UpdateStatusTaskRequest, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'request' is not null or undefined
			if (request === null || request === undefined) {
				throw new RequiredError('request', 'Required parameter request was null or undefined when calling updateStatusTask.');
			}
			let localVarPath = `/api/content/public/municipality_tasks/update_municipality_tasks`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * MunicipalityTasksApi - functional programming interface
 * @export
 */
export const MunicipalityTasksApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Получение данных по актуальному состоянию прохождения этапов и информационнных данных</p>
		 * @summary Получение данных
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getMunicipalityTasks(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetMunicipalityTasks200Response> {
			const localVarFetchArgs = MunicipalityTasksApiFetchParamCreator(configuration).getMunicipalityTasks(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Скачать расписание олимпиад</p>
		 * @summary Скачать расписание олимпиад
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		olimpiadsDownload(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = MunicipalityTasksApiFetchParamCreator(configuration).olimpiadsDownload(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/pdf') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Обновление состояния</p>
		 * @summary Обновление состояния
		 * @param {Api.UpdateStatusTaskRequest} request
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		updateStatusTask(request: Api.UpdateStatusTaskRequest, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = MunicipalityTasksApiFetchParamCreator(configuration).updateStatusTask(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						return response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * MunicipalityTasksApi - factory interface
 * @export
 */
export const MunicipalityTasksApiFactory: FactoryFunction<MunicipalityTasksApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new MunicipalityTasksApi(configuration, basePath, fetch);
};

/**
 * MunicipalityTasksApi - object-oriented interface
 * @export
 * @class MunicipalityTasksApi
 * @extends {BaseAPI}
 */
export class MunicipalityTasksApi extends BaseAPI {
	/**
	 * <p>Получение данных по актуальному состоянию прохождения этапов и информационнных данных</p>
	 * @summary Получение данных
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getMunicipalityTasks(options?: RequestInit) {
		return MunicipalityTasksApiFp(this.configuration).getMunicipalityTasks(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Скачать расписание олимпиад</p>
	 * @summary Скачать расписание олимпиад
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public olimpiadsDownload(options?: RequestInit) {
		return MunicipalityTasksApiFp(this.configuration).olimpiadsDownload(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Обновление состояния</p>
	 * @summary Обновление состояния
	 * @param {Api.UpdateStatusTaskRequest} request
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public updateStatusTask(request: Api.UpdateStatusTaskRequest, options?: RequestInit) {
		return MunicipalityTasksApiFp(this.configuration).updateStatusTask(request, options)(this.fetch, this.basePath);
	}

}
/**
 * PopupsApi - fetch parameter creator
 * @export
 */
export const PopupsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Returns list popups</p>
		 * @summary Returns list of ppopups
		 * @param {number} subjectId
		 * @param {string} subjectType
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getPopups(subjectId: number, subjectType: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'subjectId' is not null or undefined
			if (subjectId === null || subjectId === undefined) {
				throw new RequiredError('subjectId', 'Required parameter subjectId was null or undefined when calling getPopups.');
			}
			// verify required parameter 'subjectType' is not null or undefined
			if (subjectType === null || subjectType === undefined) {
				throw new RequiredError('subjectType', 'Required parameter subjectType was null or undefined when calling getPopups.');
			}
			let localVarPath = `/api/content/public/popups`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (subjectId !== undefined) {
				localVarQueryParameter.append('subject_id', String(subjectId));
			}

			if (subjectType !== undefined) {
				localVarQueryParameter.append('subject_type', String(subjectType));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>logged show popup</p>
		 * @summary logged show popup
		 * @param {number} popupId
		 * @param {Api.LoggedShowPopupRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		loggedShowPopup(popupId: number, request: Api.LoggedShowPopupRequest | undefined, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'popupId' is not null or undefined
			if (popupId === null || popupId === undefined) {
				throw new RequiredError('popupId', 'Required parameter popupId was null or undefined when calling loggedShowPopup.');
			}
			let localVarPath = `/api/content/public/popups/{popup_id}/logged_show`
				.replace('{popup_id}', encodeURIComponent(String(popupId)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * PopupsApi - functional programming interface
 * @export
 */
export const PopupsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Returns list popups</p>
		 * @summary Returns list of ppopups
		 * @param {number} subjectId
		 * @param {string} subjectType
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getPopups(subjectId: number, subjectType: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetPopups200Response | null> {
			const localVarFetchArgs = PopupsApiFetchParamCreator(configuration).getPopups(subjectId, subjectType, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>logged show popup</p>
		 * @summary logged show popup
		 * @param {number} popupId
		 * @param {Api.LoggedShowPopupRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		loggedShowPopup(popupId: number, request: Api.LoggedShowPopupRequest | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = PopupsApiFetchParamCreator(configuration).loggedShowPopup(popupId, request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 204) {
						return response;
					}
					if (response.status === 404) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * PopupsApi - factory interface
 * @export
 */
export const PopupsApiFactory: FactoryFunction<PopupsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new PopupsApi(configuration, basePath, fetch);
};

/**
 * PopupsApi - object-oriented interface
 * @export
 * @class PopupsApi
 * @extends {BaseAPI}
 */
export class PopupsApi extends BaseAPI {
	/**
	 * <p>Returns list popups</p>
	 * @summary Returns list of ppopups
	 * @param {number} subjectId
	 * @param {string} subjectType
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getPopups(subjectId: number, subjectType: string, options?: RequestInit) {
		return PopupsApiFp(this.configuration).getPopups(subjectId, subjectType, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>logged show popup</p>
	 * @summary logged show popup
	 * @param {number} popupId
	 * @param {Api.LoggedShowPopupRequest} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public loggedShowPopup(popupId: number, request: Api.LoggedShowPopupRequest | undefined, options?: RequestInit) {
		return PopupsApiFp(this.configuration).loggedShowPopup(popupId, request, options)(this.fetch, this.basePath);
	}

}
/**
 * RegionIndicatorsApi - fetch parameter creator
 * @export
 */
export const RegionIndicatorsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Показатели региона</p>
		 * @summary Показатели региона
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getRegionIndicators(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/region_indicators`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Вовлеченность студентов</p>
		 * @summary Вовлеченность студентов
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStudentsEngagement(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/region_indicators/students_engagement`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * RegionIndicatorsApi - functional programming interface
 * @export
 */
export const RegionIndicatorsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Показатели региона</p>
		 * @summary Показатели региона
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getRegionIndicators(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.RegionIndicatorsResponse> {
			const localVarFetchArgs = RegionIndicatorsApiFetchParamCreator(configuration).getRegionIndicators(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Вовлеченность студентов</p>
		 * @summary Вовлеченность студентов
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStudentsEngagement(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.StudentsEngagement2[]> {
			const localVarFetchArgs = RegionIndicatorsApiFetchParamCreator(configuration).getStudentsEngagement(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * RegionIndicatorsApi - factory interface
 * @export
 */
export const RegionIndicatorsApiFactory: FactoryFunction<RegionIndicatorsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new RegionIndicatorsApi(configuration, basePath, fetch);
};

/**
 * RegionIndicatorsApi - object-oriented interface
 * @export
 * @class RegionIndicatorsApi
 * @extends {BaseAPI}
 */
export class RegionIndicatorsApi extends BaseAPI {
	/**
	 * <p>Показатели региона</p>
	 * @summary Показатели региона
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getRegionIndicators(options?: RequestInit) {
		return RegionIndicatorsApiFp(this.configuration).getRegionIndicators(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Вовлеченность студентов</p>
	 * @summary Вовлеченность студентов
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getStudentsEngagement(options?: RequestInit) {
		return RegionIndicatorsApiFp(this.configuration).getStudentsEngagement(options)(this.fetch, this.basePath);
	}

}
/**
 * SubjectSchoolsApi - fetch parameter creator
 * @export
 */
export const SubjectSchoolsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getSubjectSchools(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/subject_schools`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Returns list of schools</p>
		 * @summary Returns list of schools
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getUserDataStudentCount(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/schools_user_data/student_count`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Set student count</p>
		 * @summary Set student count
		 * @param {Api.SetUserDataStudentCountRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		setUserDataStudentCount(request: Api.SetUserDataStudentCountRequest | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/schools_user_data/student_count`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * SubjectSchoolsApi - functional programming interface
 * @export
 */
export const SubjectSchoolsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Параметры по умолчанию для выпадашек</p>
		 * @summary Параметры по умолчанию для выпадашек
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getSubjectSchools(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetSubjectSchools200Response[]> {
			const localVarFetchArgs = SubjectSchoolsApiFetchParamCreator(configuration).getSubjectSchools(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 401) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					if (response.status === 403) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Returns list of schools</p>
		 * @summary Returns list of schools
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getUserDataStudentCount(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetUserDataStudentCount200Response[]> {
			const localVarFetchArgs = SubjectSchoolsApiFetchParamCreator(configuration).getUserDataStudentCount(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Set student count</p>
		 * @summary Set student count
		 * @param {Api.SetUserDataStudentCountRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		setUserDataStudentCount(request: Api.SetUserDataStudentCountRequest | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = SubjectSchoolsApiFetchParamCreator(configuration).setUserDataStudentCount(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 201) {
						return response;
					}
					if (response.status === 401) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * SubjectSchoolsApi - factory interface
 * @export
 */
export const SubjectSchoolsApiFactory: FactoryFunction<SubjectSchoolsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new SubjectSchoolsApi(configuration, basePath, fetch);
};

/**
 * SubjectSchoolsApi - object-oriented interface
 * @export
 * @class SubjectSchoolsApi
 * @extends {BaseAPI}
 */
export class SubjectSchoolsApi extends BaseAPI {
	/**
	 * <p>Параметры по умолчанию для выпадашек</p>
	 * @summary Параметры по умолчанию для выпадашек
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getSubjectSchools(options?: RequestInit) {
		return SubjectSchoolsApiFp(this.configuration).getSubjectSchools(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Returns list of schools</p>
	 * @summary Returns list of schools
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getUserDataStudentCount(options?: RequestInit) {
		return SubjectSchoolsApiFp(this.configuration).getUserDataStudentCount(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Set student count</p>
	 * @summary Set student count
	 * @param {Api.SetUserDataStudentCountRequest} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public setUserDataStudentCount(request: Api.SetUserDataStudentCountRequest | undefined, options?: RequestInit) {
		return SubjectSchoolsApiFp(this.configuration).setUserDataStudentCount(request, options)(this.fetch, this.basePath);
	}

}
/**
 * SurveysApi - fetch parameter creator
 * @export
 */
export const SurveysApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>send survey response</p>
		 * @summary send survey response
		 * @param {Api.SurveyResponse} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		sendResponse(request: Api.SurveyResponse | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/surveys`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * SurveysApi - functional programming interface
 * @export
 */
export const SurveysApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>send survey response</p>
		 * @summary send survey response
		 * @param {Api.SurveyResponse} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		sendResponse(request: Api.SurveyResponse | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
			const localVarFetchArgs = SurveysApiFetchParamCreator(configuration).sendResponse(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 204) {
						return response;
					}
					if (response.status === 422) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * SurveysApi - factory interface
 * @export
 */
export const SurveysApiFactory: FactoryFunction<SurveysApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new SurveysApi(configuration, basePath, fetch);
};

/**
 * SurveysApi - object-oriented interface
 * @export
 * @class SurveysApi
 * @extends {BaseAPI}
 */
export class SurveysApi extends BaseAPI {
	/**
	 * <p>send survey response</p>
	 * @summary send survey response
	 * @param {Api.SurveyResponse} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public sendResponse(request: Api.SurveyResponse | undefined, options?: RequestInit) {
		return SurveysApiFp(this.configuration).sendResponse(request, options)(this.fetch, this.basePath);
	}

}
/**
 * TeacherReviewsApi - fetch parameter creator
 * @export
 */
export const TeacherReviewsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>get list of teacher review</p>
		 * @summary get list of teacher review
		 * @param {Api.GetTeacherReviewsRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTeacherReviews(request: Api.GetTeacherReviewsRequest | undefined, options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/teacher_reviews`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'POST' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarHeaderParameter.set('Content-Type', 'application/json');

			localVarRequestOptions.headers = localVarHeaderParameter;
	
			if (request !== undefined) {
				localVarRequestOptions.body = JSON.stringify(request || {});
			}

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * TeacherReviewsApi - functional programming interface
 * @export
 */
export const TeacherReviewsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>get list of teacher review</p>
		 * @summary get list of teacher review
		 * @param {Api.GetTeacherReviewsRequest} [request]
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTeacherReviews(request: Api.GetTeacherReviewsRequest | undefined, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetTeacherReviews200Response[]> {
			const localVarFetchArgs = TeacherReviewsApiFetchParamCreator(configuration).getTeacherReviews(request, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					if (response.status === 404) {
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * TeacherReviewsApi - factory interface
 * @export
 */
export const TeacherReviewsApiFactory: FactoryFunction<TeacherReviewsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new TeacherReviewsApi(configuration, basePath, fetch);
};

/**
 * TeacherReviewsApi - object-oriented interface
 * @export
 * @class TeacherReviewsApi
 * @extends {BaseAPI}
 */
export class TeacherReviewsApi extends BaseAPI {
	/**
	 * <p>get list of teacher review</p>
	 * @summary get list of teacher review
	 * @param {Api.GetTeacherReviewsRequest} [request]
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTeacherReviews(request: Api.GetTeacherReviewsRequest | undefined, options?: RequestInit) {
		return TeacherReviewsApiFp(this.configuration).getTeacherReviews(request, options)(this.fetch, this.basePath);
	}

}
/**
 * TsokApi - fetch parameter creator
 * @export
 */
export const TsokApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Активные и зарегистрированные учителя, ученики в школах</p>
		 * @summary Статистика активности по школам (муниципалитетам)
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokActivityStatistics(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/tsok/activities`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета</p>
		 * @summary Выгрузка отчета
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokActivityStatisticsXlsx(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/tsok/activities/xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>В разделе учитываются ученики, выполнявшие интерактивные задания на Учи.ру или выполнявшие задания и упражнения с автоматической проверкой</p>
		 * @summary Статистика aктивности учеников на сервисах Учи.ру
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokStatisticBySchoolSubjects(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/tsok/by_school_subjects`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка отчета</p>
		 * @summary Выгрузка отчета
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokStatisticBySchoolSubjectsXlsx(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/tsok/by_school_subjects/xlsx`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Активные и выполнили условия</p>
		 * @summary Статистика по месяцам
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokStatisticsByMonths(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/tsok/statistic_by_month`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Сколько активировали доступ, регулярно занимаются, сколько всего учеников в регионе</p>
		 * @summary Общие показатели
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokTotals(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/tsok/totals`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * TsokApi - functional programming interface
 * @export
 */
export const TsokApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Активные и зарегистрированные учителя, ученики в школах</p>
		 * @summary Статистика активности по школам (муниципалитетам)
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokActivityStatistics(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TsokActivity[]> {
			const localVarFetchArgs = TsokApiFetchParamCreator(configuration).getTsokActivityStatistics(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета</p>
		 * @summary Выгрузка отчета
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokActivityStatisticsXlsx(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = TsokApiFetchParamCreator(configuration).getTsokActivityStatisticsXlsx(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>В разделе учитываются ученики, выполнявшие интерактивные задания на Учи.ру или выполнявшие задания и упражнения с автоматической проверкой</p>
		 * @summary Статистика aктивности учеников на сервисах Учи.ру
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokStatisticBySchoolSubjects(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TsokStatisticBySchoolSubjectsItem[]> {
			const localVarFetchArgs = TsokApiFetchParamCreator(configuration).getTsokStatisticBySchoolSubjects(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка отчета</p>
		 * @summary Выгрузка отчета
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokStatisticBySchoolSubjectsXlsx(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = TsokApiFetchParamCreator(configuration).getTsokStatisticBySchoolSubjectsXlsx(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
							return response.blob();
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Активные и выполнили условия</p>
		 * @summary Статистика по месяцам
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokStatisticsByMonths(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.TsokStatisticByMonth2[]> {
			const localVarFetchArgs = TsokApiFetchParamCreator(configuration).getTsokStatisticsByMonths(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Сколько активировали доступ, регулярно занимаются, сколько всего учеников в регионе</p>
		 * @summary Общие показатели
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getTsokTotals(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetTsokTotals200Response> {
			const localVarFetchArgs = TsokApiFetchParamCreator(configuration).getTsokTotals(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * TsokApi - factory interface
 * @export
 */
export const TsokApiFactory: FactoryFunction<TsokApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new TsokApi(configuration, basePath, fetch);
};

/**
 * TsokApi - object-oriented interface
 * @export
 * @class TsokApi
 * @extends {BaseAPI}
 */
export class TsokApi extends BaseAPI {
	/**
	 * <p>Активные и зарегистрированные учителя, ученики в школах</p>
	 * @summary Статистика активности по школам (муниципалитетам)
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTsokActivityStatistics(options?: RequestInit) {
		return TsokApiFp(this.configuration).getTsokActivityStatistics(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета</p>
	 * @summary Выгрузка отчета
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTsokActivityStatisticsXlsx(options?: RequestInit) {
		return TsokApiFp(this.configuration).getTsokActivityStatisticsXlsx(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>В разделе учитываются ученики, выполнявшие интерактивные задания на Учи.ру или выполнявшие задания и упражнения с автоматической проверкой</p>
	 * @summary Статистика aктивности учеников на сервисах Учи.ру
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTsokStatisticBySchoolSubjects(options?: RequestInit) {
		return TsokApiFp(this.configuration).getTsokStatisticBySchoolSubjects(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка отчета</p>
	 * @summary Выгрузка отчета
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTsokStatisticBySchoolSubjectsXlsx(options?: RequestInit) {
		return TsokApiFp(this.configuration).getTsokStatisticBySchoolSubjectsXlsx(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Активные и выполнили условия</p>
	 * @summary Статистика по месяцам
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTsokStatisticsByMonths(options?: RequestInit) {
		return TsokApiFp(this.configuration).getTsokStatisticsByMonths(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Сколько активировали доступ, регулярно занимаются, сколько всего учеников в регионе</p>
	 * @summary Общие показатели
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getTsokTotals(options?: RequestInit) {
		return TsokApiFp(this.configuration).getTsokTotals(options)(this.fetch, this.basePath);
	}

}
/**
 * WebinarsApi - fetch parameter creator
 * @export
 */
export const WebinarsApiFetchParamCreator = function (configuration?: Configuration) {
	return {
		/**
		 * <p>Returns  webinars statistics</p>
		 * @summary Returns webinars statistics
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStatistics(options: RequestInit = {}): FetchArgs {
			let localVarPath = `/api/content/public/webinars/statistics`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Returns list of webinars</p>
		 * @summary Returns list of webinars
		 * @param {number} subjectId
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getWebinars(subjectId: number, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'subjectId' is not null or undefined
			if (subjectId === null || subjectId === undefined) {
				throw new RequiredError('subjectId', 'Required parameter subjectId was null or undefined when calling getWebinars.');
			}
			let localVarPath = `/api/content/public/webinars`;
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (subjectId !== undefined) {
				localVarQueryParameter.append('subject_id', String(subjectId));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
		/**
		 * <p>Выгрузка списка</p>
		 * @summary Выгрузка списка
		 * @param {number} [subjectId] <p>subject_id</p>
		 * @param {string} month <p>month</p>
		 * @param {string} fileName <p>file_name</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getWebinarsPdf(subjectId: number | undefined, month: string, fileName: string, options: RequestInit = {}): FetchArgs {
			// verify required parameter 'month' is not null or undefined
			if (month === null || month === undefined) {
				throw new RequiredError('month', 'Required parameter month was null or undefined when calling getWebinarsPdf.');
			}
			// verify required parameter 'fileName' is not null or undefined
			if (fileName === null || fileName === undefined) {
				throw new RequiredError('fileName', 'Required parameter fileName was null or undefined when calling getWebinarsPdf.');
			}
			let localVarPath = `/api/content/public/webinars/pdf/{month}/{file_name}`
				.replace('{month}', encodeURIComponent(String(month)))
				.replace('{file_name}', encodeURIComponent(String(fileName)));
			const localVarPathQueryStart = localVarPath.indexOf("?");
			const localVarRequestOptions: RequestInit = Object.assign({ method: 'GET' }, options);
			const localVarHeaderParameter: Headers = options.headers ? new Headers(options.headers) : new Headers();
			const localVarQueryParameter = new URLSearchParams(localVarPathQueryStart !== -1 ? localVarPath.substring(localVarPathQueryStart + 1) : "");
			if (localVarPathQueryStart !== -1) {
				localVarPath = localVarPath.substring(0, localVarPathQueryStart);
			}

			if (subjectId !== undefined) {
				localVarQueryParameter.append('subject_id', String(subjectId));
			}

			localVarRequestOptions.headers = localVarHeaderParameter;

			const localVarQueryParameterString = localVarQueryParameter.toString();
			if (localVarQueryParameterString) {
				localVarPath += "?" + localVarQueryParameterString;
			}
			return {
				url: localVarPath,
				options: localVarRequestOptions,
			};
		},
	}
};

/**
 * WebinarsApi - functional programming interface
 * @export
 */
export const WebinarsApiFp = function(configuration?: Configuration) {
	return {
		/**
		 * <p>Returns  webinars statistics</p>
		 * @summary Returns webinars statistics
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getStatistics(options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetStatistics200Response> {
			const localVarFetchArgs = WebinarsApiFetchParamCreator(configuration).getStatistics(options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Returns list of webinars</p>
		 * @summary Returns list of webinars
		 * @param {number} subjectId
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getWebinars(subjectId: number, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<Api.GetWebinars200Response[]> {
			const localVarFetchArgs = WebinarsApiFetchParamCreator(configuration).getWebinars(subjectId, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/json') {
							return response.json() as any;
						}
						throw response;
					}
					throw response;
				});
			};
		},
		/**
		 * <p>Выгрузка списка</p>
		 * @summary Выгрузка списка
		 * @param {number} [subjectId] <p>subject_id</p>
		 * @param {string} month <p>month</p>
		 * @param {string} fileName <p>file_name</p>
		 * @param {RequestInit} [options] Override http request option.
		 * @throws {RequiredError}
		 */
		getWebinarsPdf(subjectId: number | undefined, month: string, fileName: string, options?: RequestInit): (fetch?: FetchAPI, basePath?: string) => Promise<string | Blob> {
			const localVarFetchArgs = WebinarsApiFetchParamCreator(configuration).getWebinarsPdf(subjectId, month, fileName, options);
			return (fetch: FetchAPI = defaultFetch, basePath: string = BASE_PATH) => {
				return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
					const contentType = response.headers.get('Content-Type');
					const mimeType = contentType ? contentType.replace(/;.*/, '') : undefined;
					
					if (response.status === 200) {
						if (mimeType === 'application/pdf') {
							return response.blob();
						}
						throw response;
					}
					if (response.status === 404) {
						if (mimeType === 'application/json') {
							throw response;
						}
						throw response;
					}
					throw response;
				});
			};
		},
	}
};

/**
 * WebinarsApi - factory interface
 * @export
 */
export const WebinarsApiFactory: FactoryFunction<WebinarsApi> = function (configuration?: Configuration, basePath?: string, fetch?: FetchAPI) {
	return new WebinarsApi(configuration, basePath, fetch);
};

/**
 * WebinarsApi - object-oriented interface
 * @export
 * @class WebinarsApi
 * @extends {BaseAPI}
 */
export class WebinarsApi extends BaseAPI {
	/**
	 * <p>Returns  webinars statistics</p>
	 * @summary Returns webinars statistics
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getStatistics(options?: RequestInit) {
		return WebinarsApiFp(this.configuration).getStatistics(options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Returns list of webinars</p>
	 * @summary Returns list of webinars
	 * @param {number} subjectId
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getWebinars(subjectId: number, options?: RequestInit) {
		return WebinarsApiFp(this.configuration).getWebinars(subjectId, options)(this.fetch, this.basePath);
	}

	/**
	 * <p>Выгрузка списка</p>
	 * @summary Выгрузка списка
	 * @param {number} [subjectId] <p>subject_id</p>
	 * @param {string} month <p>month</p>
	 * @param {string} fileName <p>file_name</p>
	 * @param {RequestInit} [options] Override http request option.
	 * @throws {RequiredError}
	 */
	public getWebinarsPdf(subjectId: number | undefined, month: string, fileName: string, options?: RequestInit) {
		return WebinarsApiFp(this.configuration).getWebinarsPdf(subjectId, month, fileName, options)(this.fetch, this.basePath);
	}

}

/**
 * We sometimes represent dates as strings (in models) and as Dates (in parameters) so this
 * function converts them both to a string.
 */
function dateToString(value: Date | string | undefined): string | undefined {
	if (value instanceof Date) {
		return value.toISOString();
	} else if (typeof value === 'string') {
		return value;
	} else {
		return undefined;
	}
}
